import { Book, Category } from '@apis/index'
import { Config } from '@apis/types'
import Column from '@components/column'
import Image from '@components/image'
import Typography from '@components/typography'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import GenresLoader from './loader/genresLoading'
import { GenreImageWrapper, GenreListing } from './style'

const Genres = ({ params, setParams }) => {
  const [activeGenre, setActiveGenre] = useState(null)

  const fetchGenres = async () => {
    await Category.getAll({}).catch(() => {})
  }

  const { data: booksCategories, loading } = useSelector(
    (state: any) => state.bookCategories,
  )

  useEffect(() => {
    if (!booksCategories?.length) fetchGenres()
  }, [booksCategories?.length])

  const fetchBooks = async (action: Config['store']['action'], params: any) => {
    await Book.getBooks(action, params).catch((error) => {
      console.error('Error fetching books:', error)
    })
  }

  const handleGenreClick = (genreName) => {
    if (genreName === activeGenre) {
      setActiveGenre(null)
      fetchBooks('set', { ...params, category: '' })
    } else {
      const updateparams = { ...params, category: genreName }
      setActiveGenre(genreName)
      setParams(updateparams)
      fetchBooks('set', updateparams)
    }
  }
  return (
    <GenreListing>
      {!!loading ? (
        Array(10)
          .fill(0)
          .map((_, index) => <GenresLoader key={index.toString()} />)
      ) : !!booksCategories?.length ? (
        <>
          {booksCategories.map((book, index) => (
            <Column
              key={book.id}
              alignItems="center"
              styleColumn={`
              text-align: center; 
              max-width: 120px; 
              @media (max-width: 640px) { max-width: 70px; }
              cursor: pointer; 
              flex-shrink: 0;
              transition: transform 0.3s ease;
              ${activeGenre === book.name ? 'transform: scale(1.1);' : ''}
            `}
              onClick={() => handleGenreClick(book.name)}
            >
              <GenreImageWrapper
                className={activeGenre === book.name ? 'active' : ''}
                colorIndex={index}
              >
                <Image
                  src={`${process.env.BUCKET_URL}/${book?.image}`}
                  customStyle={`
                  width: 48px; height: 48px; 
                  @media (max-width: 640px) { width: 32px; height: 32px; }  
                  object-fit: cover; 
                  position: absolute; 
                  top: 50%; 
                  left: 50%; 
                  transform: translate(-50%, -50%);
                `}
                />
              </GenreImageWrapper>

              <Typography
                variant="p"
                styleText={'@media (max-width: 640px) {font-size: 13px;}'}
              >
                {book.name}
              </Typography>
            </Column>
          ))}
        </>
      ) : (
        <Typography content="No data" />
      )}
    </GenreListing>
  )
}

export default Genres
